import { AuthGaurdService } from './services/auth-gaurd.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CoachinghubComponent } from './coachinghub/coachinghub.component';


const routes: Routes = [
  // { path: '', pathMatch: "full", redirectTo: "" },
  { path: '', loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule) },
  { path: 'claims', loadChildren: () => import('./claims/claims.module').then(m => m.ClaimsModule) },
  { path: 'managepractice', loadChildren: () => import('./manage-practice/Manage-Practice.module').then(m => m.ManagePracticeModule) },
  { path: 'availability', loadChildren: () => import('./availability/availability.module').then(m => m.AvailabilityModule) },
  { path: 'notification', loadChildren: () => import('./notification/notification.module').then(m => m.NotificationModule) },
  { path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule) },
  { path: 'contactus', loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactUsModule) },
  { path: 'viewattachment', loadChildren: () => import('./document-view/document-view.module').then(m => m.DocumentViewModule) },
  { path: 'coachinghub', component: CoachinghubComponent },
  { path: '**', loadChildren: () => import('./not-found/not-found.module').then(m => m.NotFoundModule) },

];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
  providers: [AuthGaurdService],
  declarations: []
})
export class AppRoutingModule { }